export default "__VITE_ASSET__BPgtKO5l__"